/**
 * 业务应用的国际化文件：<英文>
 *
 * 在html属性中的使用示例：（注意属性名字前要有冒号）
 * <el-tooltip :content="$t('m.notice')" placement="bottom">
 * 在html模版中的使用示例：
 * <span>{{ $t('m.welcome') }}</span>
 * 在js代码中的使用示例：
 * window.document.title = this.$t('m.projectTitle')
 * 支持动态属性示例：
 * {{ $t(`m.${scope.row.operationStatus}`) }}
 *
 * 注意1:
 *    公用的国际化标识是以'c.'开头,
 *    业务应用的国际化默认是以'm.'开头, 可以自行调整
 *    但是不可以使用c(公用的)和el(ElementUI的), 避免冲突
 * 注意2:
 *    属性名称使用首字母小写的驼峰格式命名, 或下划线分隔单词
 *    必须使用英文，禁止使用拼音及拼音简写
 *    尽量做到望文知义，可以长一些，再长一些，保证代码可阅读性
 *    正确：projectTitle, studentName, min_waiting_time
 *    正确：loginPasswordVerifyFailedAutoUnlockPeriod,即：登录密码验证失败自动解锁时长
 *    正确：login_collision_attack_failed_count,即：登录碰撞攻击失败次数
 *    错误：name(这是什么阿猫阿狗), shijian(拼音时间或是事件或是??), pyjx(我猜是拼音简写, 错! 正确答案, 嗯...让我想想)
 * @author luwei
 * @version 1.0.0, 2019-03-16
 */
export const m = {
  // 业务项目名称, 必填项
  //projectTitle: '四川省外事管理申报系统',
  projectTitle: 'Oriental Electric Foreign Affairs Management Service System',
  //projectTitle: 'Nuo Jun An Foreign Affairs Management Service Platform',
  auditLog: {
    "reset": "Reset",
    "name": "Name",
    "high": "High",
    "medium": "Medium",
    "low": "Low",
    "code": "Code",
    "level": "Level",
    "confirmResetAuditType": "Confirm to reset audit type?",
    "resetSuccess": "Reset Successful",
    userId: 'User ID',
    userAccount: 'User Account',
    realName: 'Real Name',
    ipAddr: 'IP Address',
    macAddr: 'MAC Address',
    hostName: 'Host Name',
    clientType: 'Client Type',
    userAgent: 'User Agent',
    catgory: 'Log Category',
    itemCode: 'Audit Item Code',
    operateType: 'Operation Type',
    operateTime: 'Operation Time',
    operation: 'Function Point',
    sqlLikeFields: 'User Account, IP Address, User Agent',
    auditLog: 'Audit Log Query',
    methodName: 'Method Name'
  },
  dataxTask: {
    appId: 'App ID',
    resourceTag: 'Resource Tag',
    taskName: 'Task Name',
    groupName: 'Task Group',
    transferType: 'Transfer Type',
    taskDesc: 'Task Description',
    sqlLikeFields: 'Resource Tag, Task Name, Task Group, Task Description',
    dataxTask: 'Local Data Exchange Service Task Definition'
  },
  httpAsync: {
    resourceTag: 'Resource Tag',
    result: 'Business Data',
    submitStatus: 'Submission Status',
    httpAsync: 'HTTP Asynchronous Processing Record'
  },
  filePush: {
    resourceTag: 'Resource Tag',
    filePath: 'File Path',
    submitStatus: 'Submission Status',
    sqlLikeFields: 'Resource Tag, File Path',
    filePush: 'File Push Record'
  },
  dataxStatusLocal: {
    resourceTag: 'Resource Tag',
    code: 'Result Code',
    msg: 'Result Message',
    linkId: 'Linked Business ID',
    fileName: 'File Name',
    submitStatus: 'Submission Status',
    sqlLikeFields: 'Resource Tag, Result Message, File Name',
    dataxStatusLocal: 'Local Processing Status Record'
  },
  dataxStatusThird: {
    resourceTag: 'Resource Tag',
    code: 'Result Code',
    msg: 'Result Message',
    linkId: 'Linked Business ID',
    fileName: 'File Name',
    handleStatus: 'Processing Status',
    handleNote: 'Processing Note',
    sqlLikeFields: 'Resource Tag, Result Message, File Name',
    dataxStatusThird: 'Third-party Processing Status Record'
  },
  user: {
    userAccount: 'User Account',
    passwd: 'User Password',
    salt: 'Encryption Salt',
    userPersonAprvStatus: 'Person Status',
    userRoleAprvStatus: 'Role Status',
    status: 'User Status',
    userType: 'User Type',
    personId: 'Linked Person',
    orgId: 'Affiliated Organization',
    bindSerialNumber: 'Bound Certificate Number',
    sqlLikeFields: 'User Account',
    checkRoles: 'Please select roles',
    resetPwd: 'Reset Password',
    user: 'User Account',
    useUsbkeyAccount: 'Certificate as Account'
  },
  menu: {
    menuName: 'Menu Name',
    menuNote: 'Menu Description',
    menuUri: 'Menu Address',
    menuIcon: 'Menu Icon',
    orderBy: 'Menu Order',
    detail: 'Menu Note',
    "approvalEndpoint": "Approval Endpoint",
    "declarationEndpoint": "Declaration Endpoint",
    "mobileEndpoint": "Mobile Endpoint",
    "addPrimaryMenu": "Add Primary Menu",
    "associatedFunction": "Associated Function",
    "pleaseEnterFunctionNameOrOverviewForFuzzySearch": "Please enter function name/overview for fuzzy search",
    "isAssociated": "Is Associated",
    "no": "No",
    "yes": "Yes",
    "functionName": "Function Name",
    "functionOverview": "Function Overview",
    "userInformationDetails": "User Information Details",
    "roleDescription": "Role Description",
    "pleaseFillInMenuName": "Please fill in menu name",
    "pleaseSelectMenuIcon": "Please select menu icon",
    "home": "Home",
    "menuHasMaintainedAssociatedFunctionsPleaseClearAssociatedFunctionsBeforeAddingSubmenus": "Menu has maintained associated functions, please clear associated functions before adding submenus",
    "modificationSuccessful": "Modification Successful",
    "deletionSuccessful": "Deletion Successful",
    "moveUp": "Move Up",
    "moveDown": "Move Down",
    "authorizeRoles": "Authorize Roles",
    "addSubmenu": "Add Submenu",
    "pleaseSelectMenuToAuthorize": "Please select menu to authorize",
    "pleaseSelectRoleBeforeSaving": "Please select role before saving",
    "confirmToAuthorize": "Confirm to authorize",
    "authorizeSelectedRoles": "Authorize selected roles?",
    "andSubmenusAuthorizedToSelectedRoles": "and submenus to selected roles?",
    "menuAuthorizationRoleHint": "Menu Authorization Role Hint",
    "menuAuthorizationSuccess": "Menu Authorization Successful"
  },
  parameter: {
    oneName: 'Primary Group Name',
    oneDesc: 'Primary Group Description',
    twoName: 'Secondary Group Name',
    twoDesc: 'Secondary Group Description',
    paramName: 'Parameter Name',
    paramDesc: 'Parameter Description',
    paramValue: 'Parameter Value',
    paramExtra: 'Parameter Extended Value',
    sqlLikeFields:
      'Primary Group Name, Primary Group Description, Secondary Group Name, Secondary Group Description, Parameter Name, Parameter Description',
    parameter: 'System Parameters'
  },
  upgradeConfig: {
    parentId: 'App Name',
    dataType: 'Release Time',
    dataTag: 'Fixed Tag',
    dataName: 'Version Number',
    dataText: 'Parameter Upgrade JSON',
    sqlLikeFields: 'Version Number',
    upgradeConfig: 'App Configuration Parameter Upgrade Management'
  },
  flowBusiness: {
    nodeKey: 'Node Identifier',
    businessName: 'Business Name',
    remarks: 'Description',
    flowBusiness: 'Process Business Module Table'
  },
  sysSequence: {
    type: 'Sequence Number Category',
    subType: 'Printed Piece Type',
    dateType: 'Sequence Number Date Format',
    fowNum: 'Sequence Number Length',
    value: 'Current Sequence Number',
    prefix: 'Sequence Number Prefix',
    suffix: 'Sequence Number Suffix',
    cancel: 'Cancel Sequence Number',
    decrement: 'Reduction Degree',
    sysSequence: 'Sequence Number Information Table',
    "serialNumberUsage": "Serial Number Usage",
    "usingOrganization": "Using Organization",
    "maxValue": "Max Value",
    "writeOffSerialNumber": "Cancel Serial Number",
    "startNumber": "Start Number",
    "endNumber": "End Number",
    "serialNumberCode": "Serial Number Code",
    "serialNumberFormatExample": "Serial Number Format Example",
    "writeOffSuccess": "Cancel Successful",
    "normal": "Normal"
  },
  dyndictionary: {
    id: 'ID',
    dicttype: 'Dictionary Type',
    parentcode: 'Parent Dictionary',
    dictname: 'Dictionary Name',
    description: 'Description',
    hardcode: 'Hard Code',
    code: 'Code',
    dictno: 'Dictionary Number',
    dictKey: 'Dictionary Key',
    dyndictionary: 'Data Dictionary Table'
  },
  country: {
    countrycode: 'Country Code',
    abbr2: 'Two-letter Country Code',
    abbr3: 'Three-letter Country Code',
    fullenname: 'Full English Name',
    shortenname: 'Abbreviated English Name',
    fullcnname: 'Full Chinese Name',
    shortcnname: 'Abbreviated Chinese Name',
    continentid: 'Continent',
    lastupdate: 'Last Update Date',
    restricted: 'Controlled Indicator',
    remarks: 'Remarks',
    isIndex: 'Occupies Plan Index',
    country: 'Country Basic Information Table',
    isLatinAmerica: 'Belongs to Latin America',
    signDays: 'Visa Processing Days'
  },
  noticeManage: {
    title: 'Title',
    showTimeStart: 'Display Start',
    showTimeEnd: 'Display End',
    showPriority: 'Priority',
    articleType: 'Article Type',
    articleSource: 'Source of Article',
    articleContent: 'Article Content',
    articleSummary: 'Article Summary',
    publishArea: 'Publishing Area',
    publishStatus: 'Publishing Status',
    publishTime: 'Publication Date',
    noticeManage: 'Notice Management'
  },
  visitunit: {
    visitUnit: 'Visited Unit',
    visitResult: 'Visit Outcome',
    vip: 'VIP',
    talkMatter: 'Matters Discussed',
    nextTodo: 'Next Steps',
    visitunit: 'Visit Unit Information'
  },
  sumOrg: {
    orgCode: 'Organization Code',
    parentCode: 'Parent Code',
    provinceSystemCode: 'Province System Code',
    fullName: 'Organization Full Name',
    shortName: 'Organization Short Name',
    creditCode: 'Credit Code',
    leader: 'Administrator',
    zoneCode: 'Affiliated Area',
    unitNature: 'Organization Nature',
    unitCategory: 'Industry Type',
    unitClassification: 'Organization Classification',
    approvalAuthority: 'Has Approval Authority',
    passportAuthority: 'Has Passport Custody Authority',
    applyDroit: 'Has Application Authority',
    seqIndex: 'Organization Display Order',
    remarks: 'Remarks',
    nodeLevel: 'Organization Level',
    status: 'Status',
    expireDate: 'Service Expiry Date',
    sumOrg: 'Organization Table Information',
    "organization": "Organization",
    "fullName": "Full Name",
    "enterFullOrganizationNameConsistentWithSeal": "Enter the full organization name consistent with the official seal",
    "shortName": "Short Name",
    "enterRecordedOrganizationShortName": "Enter the recorded organization short name",
    "organizationCode": "Organization Code",
    "organizationCreatedSuccessfullyAutomaticallyGenerated": "The organization is automatically generated upon successful creation",
    "type": "Type",
    "selectUnitClassification": "Select organization classification",
    "selectUnitNature": "Select organization nature",
    "selectIfHavePassportCustodyRight": "Select whether there is passport custody authority",
    "selectIfHaveApprovalRight": "Select whether there is approval authority",
    "enterAdministratorNameForRecord": "Enter the administrator's name recorded by the organization",
    "contactPhone": "Contact Phone",
    "enterAdministratorContactPhoneForRecord": "Enter the administrator's contact phone recorded by the organization",
    "responsibleLeader": "Responsible Leader",
    "selectResponsibleLeaderOfThisUnit": "Select the responsible leader of this organization",
    "filterByKeyWord": "Filter by keyword",
    "phone": "Phone",
    "requestDocumentHeader": "Request Document Header",
    "enterRequestDocumentHeader": "Enter request document header",
    "organizationSealImage": "Organization Seal Image",
    "icon": "Icon",
    "fileType": "File Type",
    "header": "Header",
    "enterHeader": "Enter header",
    "enterFullOrganizationName": "Enter organization full name",
    "enterShortOrganizationName": "Enter organization short name",
    "saveOrganizationInfoBeforeSettings": "Please save organization information before settings",
    "confirmDeleteSealImageContinue": "Confirm to delete the seal image, continue?",
    "uploadSealImageSizeCannotExceed1MB": "The uploaded seal image size cannot exceed 1MB!",
    "uploadImageWidthAndHeightCannotExceed800Pixels": "The uploaded image width and height cannot exceed 800 pixels",
    "pleaseEnterFullOrganizationName": "Please enter organization full name",
    "pleaseEnterShortOrganizationName": "Please enter organization short name",
    "pleaseEnterAdministrator": "Please enter administrator",
    "isDisabled": "Is Disabled",
    "pleaseSelectIsDisabled": "Please select whether to disable",
    "approvalMethod": "Approval Method",
    "setValidityPeriod": "Set Validity Period",
    "unban": "Unban",
    "ban": "Ban",
    "confirmDisableOrganization": "Confirm to disable the organization?",
    "confirmUnbanOrganization": "Confirm to unban the organization?",
    "setServiceValidityPeriod": "Set Service Validity Period",
    "salesPerson": "Salesperson",
    "salesPersonName": "Salesperson Name",
    "purchaseDate": "Purchase Date",
    "selectDate": "Select Date",
    "serviceValidityDeadline": "Service Validity Deadline",
    "validDate": "Valid Date",
    "pleaseEnterSalesPerson": "Please enter salesperson",
    "pleaseEnterPurchaseDate": "Please enter purchase date",
    "pleaseEnterServiceValidDate": "Please enter service valid date",
    "setValidityPeriodSuccessfully": "Set validity period successfully",
    "setApprovalMethod": "Set Approval Method",
    "warmPrompt": "Warm Prompt: Here you can set the approval method according to your organization's actual situation",
    "organizationName": "Organization Name",
    "businessType": "Business Type",
    "pleaseSelectApprovalMethod": "Please select approval method",
    "pleaseSaveDataBeforeOperation": "Please save data before operation",
    "selectAll": "Select All",
    "roleAuthorization": "Role Authorization",
    "primaryMenu": "Primary Menu",
    "subMenu": "Submenu"
  },
  sysDict: {
    dictName: 'Dictionary Name',
    dictEname: 'Dictionary English Name',
    dictSpec: 'Dictionary Standard',
    dictType: 'Dictionary Type',
    remarks: 'Remarks',
    orderNo: 'Display Order',
    status: 'Status',
    sysDict: 'Dictionary Table Information',
    "addDictionary": "Add Dictionary",
    "pleaseEnterDictionaryNameOrRelatedBusiness": "Please enter dictionary name or related business",
    "dictionaryItemStatus": "Dictionary Item Status",
    "normal": "Normal",
    "initial": "Initial",
    "viewSubordinate": "View Subordinate",
    "addSubordinate": "Add Subordinate",
    "enable": "Enable",
    "initiallyEnabled": "Initially Enabled",
    "dictionaryItemCode1": "Dictionary Item Code 1",
    "dictionaryItemCode2": "Dictionary Item Code 2",
    "confirmCancelDictionaryItemCustomization": "Confirm to cancel dictionary item customization?",
    "confirmDictionary": "Confirm to customize dictionary items for (",
    ItemCustomization: "Dictionary Item Customization",
    "cancelCustomizationSuccess": "Cancel customization successfully",
    "customDictionarySuccess": "Customize dictionary successfully",
    "confirmToInitiallyEnableDictionaryItem": "Confirm to initially enable this dictionary item? It cannot be deleted once enabled.",
    "confirmToDisableDictionaryItem": "Confirm to disable this dictionary item?",
    "confirmToEnableDictionaryItem": "Confirm to enable this dictionary item?",
    "onlyInitialStatusDictionaryItemsCanBeDeleted": "Only dictionary items in initial status can be deleted!",
    "dictionaryItemNotInInitialStatus": "Dictionary item is not in initial status.",
    "deletionSuccess": "Deletion Successful",
    "pleaseSelectParentDictionaryFirst": "Please select parent dictionary first",
    "subordinateDataIsEmpty": "Subordinate data is empty",
    "operationSuccess": "Operation Successful",
    "pleaseSelectParentDictionary": "Please select parent dictionary",
    "associatedBusiness": "Associated Business",
    "pleaseEnterAssociatedBusiness": "Please enter associated business",
    "englishName": "English Name",
    "confirmSave": "Confirm to save?",
    "roleNotAssignedDictionaryManagementPagePermission": "The role does not have permission for the dictionary management page. Confirm to authorize?",
    "roleAuthorization": "Role Authorization",
    "dictionary": "Dictionary"
  },
  sysDictItem: {
    itemName: 'Dictionary Item Name',
    hardCode: 'Dictionary Item Code',
    thirdpartyHardCode: 'Other Business Dictionary Item Code',
    itemValue: 'Dictionary Item Value',
    parentId: 'Parent Dictionary Item ID',
    sysDictItem: 'Dictionary Item Table Information',
    "serialNumberInfo": "Serial Number Information",
    "suchAs": "Such as: Request document number, group number, etc.",
    "exampleCode": "Such as: ABROADPLANAPPROVALNO",
    "serialNumberDigits": "Serial Number Digits",
    "suchAsDigits": "Such as: Serial number length: 1<=serial number length<=20",
    "serialNumberExample": "Serial Number Example",
    "pleaseEnterPrefix": "Please enter prefix",
    "pleaseEnterSuffix": "Please enter suffix",
    "currentMaxSerialNumber": "Current Maximum Serial Number",
    "pleaseEnterCurrentMaxSerialNumber": "Please enter current maximum serial number",
    "pleaseSelectUsingOrganizationShortName": "Please select organization short name",
    "inputOrganizationName": "Input Organization Name",
    "dateFormat": "Date Format",
    "dateFormatExplanation": "This date format indicates that the serial number is updated according to a certain date rule. For example, [yyyyMM] means monthly update. yy represents year, MM represents month, DD represents day.",
    "suchAsDateFormat": "Such as: yyyyMMdd",
    "resetSerialNumber": "Reset Serial Number",
    "resetExplanation": "When the year or month changes, reset the serial number maximum value to 1. For example, if the date format is [yyyyMM], the current month is May, the current serial number is [2023050088], and in June, if reset is yes, the new serial number is 2023060001; if no, it is 2023060089.",
    "pleaseEnterRemarks": "Please enter remarks",
    "exceedsTwentyCharacters": "Length exceeds 20 characters",
    "details": "Details",
    "reviewPassed": "Review Passed",
    "rejectApplication": "Reject Application",
    "rejectApplicationReason": "Reject Application Reason",
    "rejectReason": "Reject Reason(",
    "userInfo": "User Information",
    "beforeModification": "Before Modification",
    "deletedNotViewable": "Deleted, not viewable",
    "afterModification": "After Modification",
    "phoneNumber": "Phone Number",
    "jobTitle": "Job Title",
    "userInfo": "User Information",
    "beforeModification": "Before Modification",
    "afterModification": "After Modification",
    "pleaseFillInRejectReasonCarefully": "Please carefully fill in the reject reason to help the applicant make adjustments"
  },
  sumUser: {
    "pleaseSelectAffiliatedOrganization": "Please select affiliated organization",
    "pleaseSelectRole": "Please select role",
    "pleaseSelectStatus": "Please select status",
    "confirmLockUser": "After locking, the user will not be able to log in. Confirm to lock the user?",
    "confirmUnlockUser": "After unlocking, the user will be able to log in. Confirm to unlock the user?",
    user: 'User',
    userAccount: 'User Name',
    personName: 'Name',
    sex: 'Gender',
    birthdate: 'Date of Birth',
    orgCode: 'Organization Code',
    status: 'User Status',
    phone: 'Phone Number',
    email: 'Email',
    position: 'Position',
    photo: 'Profile Photo',
    signPhoto: 'Electronic Signature',
    sumUser: 'User Table Information',
    password: 'Password',
    staffNo: 'Staff Number',
    roleNames: 'Role List',
    orgName: 'Organization Name',
    remarks: 'Remarks',
    operationType: 'Approval Type',
    filters: {
      org: 'Organization',
      selectArea: 'Search Scope',
      selectAreaTip: 'Please select search scope',
      personName: 'Person Name',
      personNameTip: 'Search by person name',
      phone: 'Phone Number',
      phoneTip: 'Please enter phone number',
      role: 'Role',
      status: 'Status',
      search: 'Search',
      new: 'New',
      searchScope: {
        own: 'This Organization Only',
        withSubOrg: 'This Organization and Sub-organizations'
      },
    },
    operation: {
      resetPwd: 'Reset Password',
      resetPwdSuccess: 'Reset Password Successful',
      resetPwdError: 'Reset Password Failed',
      resetPwdTip: 'Confirm to reset user {} password to (abc.123)?',
      tip: 'Tip',
      lock: 'Lock',
      lockTip: 'Confirm to解除 the association between the user and [{}]',
      unlock: 'Unlock',
      unlockTip: 'Confirm to unlock user {}?',
      userExistsTip: 'The user has been maintained in another organization. Continue to add as this organization user?',
    }
  },
  sumRole: {
    roleCode: 'Role Code',
    roleName: 'Role Name',
    status: 'Status',
    detail: 'Remarks',
    sumRole: 'Role Table Information',
    level: 'Role Level',
    saveConfirm: 'Are you sure to save?',
    deleteRowConfirm: "Are you sure to delete role '{name}'?",
    notDictMenuConfirm: "The current role '{name}' has not been assigned dictionary management page permissions. Confirm to authorize?",
    secondDeleteConfirm: "'{name}' Are you sure to delete the users associated with this role?",
    "queryByRoleNameFuzzy": "Search by role name",
    "dictionaryAuthorization": "Dictionary Authorization",
    "menuAuthorization": "Menu Authorization",
    "homePageAuthorization": "Homepage Authorization",
    "submitForReview": "Submit for Review",
    "cancelModification": "Cancel Modification",
    "confirmSubmitForReview": "Confirm to submit for review?",
    "confirmCancelModification": "Confirm to cancel modification?",
    "homeModule": "Homepage Module",
    "queryByDictionaryType": "Search by dictionary type"
  },
  sysModule: {
    moduleName: 'Module Name',
    detail: 'Remarks',
    sysModule: 'Module Table Information'
  },
  sumApi: {
    apiName: 'Permission Name',
    apiType: 'API Type',
    apiUri: 'API Path',
    apiDetail: 'API Description',
    apiClazzId: 'Affiliated Menu',
    apiTag: 'Tag',
    sumApi: 'Permission Table Information'
  },
  sumOrgApprovalWay: {
    orgCode: 'Organization Code',
    rootOrgCode: 'Primary Organization Code',
    reportApprovalWay: 'Reporting Approval Method',
    backApprovalWay: 'Return Approval Method',
    sumOrgApprovalWay: 'Organization Approval Method Table'
  },
  flow: {
    orgCode: 'Organization Code',
    flowCode: 'Process Code',
    flowName: 'Business Flow Name',
    flow: 'Process Information Table',
    owner: 'Affiliated Organization',
    isCollect: 'Is Aggregate',
    isAutoAccept: 'Is Auto Accept'
  },
  city: {
    countryId: 'Country',
    cityEname: 'City English Name',
    cityCname: 'City Chinese Name',
    currency: 'Currency',
    accommodationFee: 'Accommodation Fee',
    foodFee: 'Food Allowance',
    sundryFee: 'Miscellaneous Fee',
    accreditationFee: 'Visa Fee',
    city: 'City Basic Information Table',
    currencyLabel: 'Please select currency',
    search: {
      country: 'Country',
      city: 'City',
      countryLabel: 'Please select country',
      cityLabel: 'Search by city name'
    }
  },
  businessLog: {
    logTypeName: "Log Type",
    orgName: "Operator's Organization",
    realName: "Operator's Name",
    userName: "User Name",
    operationTypeName: "Action",
    businessTypeName: "Function Module",
    businessChildrenTypeName: "Sub-module",
    businessKey: "Business Key",
    ipAddr: "IP Address",
    businessLogTitle: "Business Log Search",
    operation: "Operation Content",
    createDate: "Date",
    "export": "Export",
    "functionSubmodule": "Function Sub-module",
    "logTime": "Log Time",
    "advancedSearch": "Advanced Search",
    "operationLog": "Operation Log",
    "businessLog": "Business Log",
    "approvalLog": "Approval Log",
    "yesterday": "Yesterday",
    "today": "Today",
    "lastWeek": "Last Week",
    "thisWeek": "This Week",
    "lastMonth": "Last Month",
    "thisMonth": "This Month",
    "logDataIsEmptyCannotExport": "Log data is empty and cannot be exported",
    "log": "Log",
    "logTime": "Log Time",
    "to": "to"
  },
  systemConfiguration: {
    "systemName": "System Name",
    "pleaseEnterSystemName": "Please enter system name",
    "pleaseUploadSystemIcon": "Please upload system icon",
    "pleaseUploadSystemBackgroundImage": "Please upload system background image",
    "systemStyle": "System Style",
    "systemIcon": "System Icon",
    "systemBackgroundImage": "System Background Image",
    "uploadIconImageSizeCannotExceed": "Uploaded icon image size cannot exceed 1MB!",
    "uploadImageWidthAndHeightCannotExceed600Pixels": "Uploaded image width cannot exceed 600 pixels, height cannot exceed 600 pixels",
    "uploadBackgroundImageSizeCannotExceed": "Uploaded background image size cannot exceed 2MB!",
    "uploadImageWidthCannotExceed1920PixelsAndHeightCannotExceed1080Pixels": "Uploaded image width cannot exceed 1920 pixels, height cannot exceed 1080 pixels",
    "confirmDeleteSystemImageAreYouSure": "Confirm to delete system image? Proceed?",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "cancelledDeletion": "Deletion cancelled",
    "successfullyAddedSystemInformation": "Successfully added system information",
    "successfullyModifiedSystemInformation": "Successfully modified system information"
  },
  rules: {
    lengthBetween: 'Length between {} and {} characters',
    "deleteThisLine": "Please delete this line, used only for the last position"
  },
  logain: {
    "welcomeLogin": "Welcome to Login",
    "inputLoginAccount": "Please enter login account",
    "inputLoginPassword": "Please enter login password",
    "inputMobileNumber": "Please enter mobile number",
    "inputSmsVerificationCode": "Please enter 6-digit SMS verification code",
    "inputUsername": "Please enter username",
    "inputPassword": "Please enter password",
    "getVerificationCode": "Get Verification Code",
    "inputMobileNumberForVerification": "Please enter mobile number",
    "usernameLogin": "Username Login",
    "smsLogin": "SMS Login",
    "userLogin": "User Login",
    "resendLater": "Resend later",
    "clickToResend": "Click to resend"
  },

  // Error Messages
  errorMsg: {
    MsgErr001: 'Failed to retrieve login information, please login again',
    MsgErr002: 'Organization does not match the login account, please login again',

    MsgErrC2001001: 'Organization plan not activated',
    MsgErrC2001002: 'All subordinate units have been published, cannot set deadline',
    MsgErrC2001003: 'Subordinate units without declaration deadlines exist, cannot publish plan',
    MsgErrC2001004: 'Organization has no direct subordinate units, cannot publish plan',
    MsgErrC2001005: 'No unpublished and unlocked subordinate units exist, cannot publish plan',
    MsgErrC2001006: 'Failed to retrieve organization information',
    MsgErrC2001007: 'Failed to activate plan',
    MsgErrC2001008: 'Error retrieving direct subordinate unit information',
    MsgErrC2001009: 'Error setting declaration deadline',
    MsgErrC20010010: 'Failed to retrieve direct subordinate unit plan index information',
    MsgErrC20010011: 'Failed to publish plan',
    MsgErrC20010012: 'Can only operate on reporting authority of direct subordinate units',
    MsgErrC20010013: 'Lock/unlock operation failed',
    MsgErrC20010014: 'Deadline cannot be empty',
    MsgErrC20010015: 'Plan year cannot be empty',
    MsgErrC20010016: 'Organization cannot be empty',
    MsgErrC20010017: 'Failed to set deadline',
    MsgErrC20010018: 'Failed to save notification information',
    MsgErrC20010019: 'Failed to retrieve notification attachment information',
    MsgErrC20010020: 'Failed to retrieve organization index information',
    MsgErrC20010021: 'Parameter id cannot be empty',

    MsgErrC2002001: 'Plan index not published',
    MsgErrC2002002: 'Plan index status cannot create new plan',
    MsgErrC2002003: 'Limited plan batches used up, cannot create new plan',
    MsgErrC2002004: 'Limited plan person times used up, cannot create new plan',
    MsgErrC2002005: 'Overdue plan reminder',
    MsgErrC2002006: 'Plan is empty',
    MsgErrC2002007: 'Please add destination',
    MsgErrC2002008: '',
    MsgErrC2002009: '',
    MsgErrC2002010: '',
    MsgErrC2002011: '',
    MsgErrC2004001:'Error retrieving approval index information',
    MsgErrC2004002:'Error retrieving final approval plan unit list',
    MsgErrC2004003:'Error retrieving unit plan list',
    MsgErrC2004004:'Error retrieving plan details',
    MsgErrC2004005:'Error retrieving destination list',
    MsgErrC2004006:'Plan approval failed',
    MsgErrC2004007:'Approval index setting failed',
    MsgErrC2004008:'Approval and notification failed',
    MsgErrC2004009:'Plan year cannot be empty',
    MsgErrC2004010:'Unit code cannot be empty',
    MsgErrC2004011:'Not a subunit of the current unit',
    MsgErrC2004012:'Plan number cannot be empty',
    MsgErrC2004013:'Plan does not exist',
    MsgErrC2004014:'Plan is associated with a group and cannot be unapproved',
    MsgErrC2004015:'Annual plan index information does not exist',
    MsgErrC2004016:'Annual plan has been published with notification, operation prohibited',
    MsgErrC2004017:'Unit plan has been notified, duplicate operation prohibited',
  },
  signRecord: {
    tableName: 'Signature Table',
    primaryKey: 'Primary Key Field',
    primaryValue: 'Primary Key Value',
    signFields: 'Signature Fields',
    signValue: 'Signature Value',
    signTime: 'Signature Time',
    signFirstTime: 'First Signature Time',
    sqlLikeFields: 'Signature Table Name, Primary Key Field Name, Primary Key Value, Signature Value',
    signRecord: 'Signature Record',
    status: 'Status'
  }
}
